const HtmlToReactParser = require('html-to-react').Parser;
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useEffect } from "react"
import { Wrapper, Content, Row, Logo } from './footer.style'


const Footer = (props: any) => {

  const htmlToReactParser = new HtmlToReactParser();
  const gatsbyImage = getImage(props.data.footeroptions.image.gatsbyImage)


  return (
    <Wrapper>
      <Content>
        <Row>
          {gatsbyImage && <GatsbyImage alt={props.data.footeroptions.image.altText} title={props.data.footeroptions.image.title} image={gatsbyImage} />}
          {htmlToReactParser.parse(props.data.footeroptions.leftcolumn)}
        </Row>
        <Row style={{ alignSelf: 'flex-end', textAlign: 'right', flexDirection: 'column' }}>
          {htmlToReactParser.parse(props.data.footeroptions.rightcolumn)}
        </Row>
      </Content>
    </Wrapper >
  )
}

export default Footer
